var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoryManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 3.52954L10.0208 17.4878H26.9792L18.5 3.52954ZM18.5 9.48508L21.4754 14.386H15.5092L18.5 9.48508ZM26.9792 20.5897C23.1404 20.5897 20.0417 23.707 20.0417 27.5688C20.0417 31.4306 23.1404 34.548 26.9792 34.548C30.8179 34.548 33.9167 31.4306 33.9167 27.5688C33.9167 23.707 30.8179 20.5897 26.9792 20.5897ZM26.9792 31.4461C24.8517 31.4461 23.125 29.7091 23.125 27.5688C23.125 25.4285 24.8517 23.6915 26.9792 23.6915C29.1067 23.6915 30.8333 25.4285 30.8333 27.5688C30.8333 29.7091 29.1067 31.4461 26.9792 31.4461ZM4.625 33.7725H16.9583V21.3651H4.625V33.7725ZM7.70833 24.467H13.875V30.6707H7.70833V24.467Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryManagement);
export default __webpack_public_path__ + "static/media/category_management.6c6bdb0da9b85e3a3815eb99be3d167e.svg";
export { ForwardRef as ReactComponent };